import Row from "@avinet/adaptive-ui-core/layout/Row";
import { Profile as ProfileModel } from "../hooks/useProfile";
import { derivedColor } from "../utils/color";
import "./Profile.scss";

export function ProfileImage({ profile }: { profile: ProfileModel }) {
  if (profile.image?.iconUrl) {
    return <img src={profile.image.iconUrl} width={40} height={40} />;
  }
  return (
    <svg viewBox="0 0 20 20" width={40} height={40}>
      <circle cx={10} cy={10} r={10} fill={derivedColor(profile.uuid)} />
      <text
        x={10}
        y={10}
        fill="white"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize={10}
        fontFamily="var(--default-font)"
      >
        {(profile.display_name ?? profile.email).substring(0, 1).toUpperCase()}
      </text>
    </svg>
  );
}

export function Profile({ profile }: { profile: ProfileModel }) {
  return (
    <Row className="profile">
      <ProfileImage profile={profile} />
      <span>{profile.display_name ?? profile.email ?? "-"}</span>{" "}
    </Row>
  );
}
